import { environment } from "../../environments/environment";

export const portalHttpVersion = {
    V1: environment.apiMiddlewareUrlForSuperAdmin + 'webapi/v1/portal/',
};

export enum portalHttpRoutes {
    PORTAL_LOGIN = 'login',
    PORTAL_FORGOT_PASSWORD = 'forgot-password',
    PORTAL_RESET_PASSWORD = 'reset-password',
    PORTAL_CHANGE_PASSWORD = 'change-password',

    //Users
    PORTAL_USERS_GET_TABLE = 'user/table/get',
    USERS_ADD_EDIT = 'user',
    //get user dropdown
    GET_COMPANY_WISE_USERS = 'user/company-id',

    // Portal-category-list

    PORTAL_CATEGORY_GET_TABLE = 'product-category/table/get',
    PORTAL_SUBSCRIPTION_GET_TABLE = 'subscription/table/get'

}